<div class="h-full flex flex-column bg-gray-50">
    <!-- Sticky Header -->
    <div class="surface-0 border-bottom-1 border-200 px-4 py-3 flex justify-content-between align-items-center shadow-1 z-1" style="position: sticky; top: 0;">
        <div class="flex align-items-center gap-3">
            <p-button icon="pi pi-arrow-left" [text]="true" [rounded]="true" (onClick)="close()"></p-button>
            <div>
                <h1 class="text-xl font-semibold m-0 text-900">
                    <ng-container *ngIf="mode === 'create'">Nueva Transferencia</ng-container>
                    <ng-container *ngIf="mode === 'approve'">Aprobar y Despachar Transferencia</ng-container>
                    <ng-container *ngIf="mode === 'receive'">Confirmar Recepción</ng-container>
                    <ng-container *ngIf="mode === 'view'">Detalle de Transferencia</ng-container>
                </h1>
                <p class="text-sm text-500 m-0 mt-1">Gestiona los movimientos entre sucursales</p>
            </div>
        </div>
        <div class="flex gap-2">
            <p-button label="Cancelar" icon="pi pi-times" [text]="true" severity="secondary" (onClick)="close()" [disabled]="loading"></p-button>
            <p-button *ngIf="mode === 'approve'" label="Rechazar" icon="pi pi-times" severity="danger" (onClick)="reject()" [loading]="loading"></p-button>
            <p-button *ngIf="mode !== 'view'" 
                      [label]="mode === 'create' ? 'Crear' : (mode === 'approve' ? 'Aprobar' : 'Recibir')" 
                      [icon]="mode === 'create' ? 'pi pi-check' : (mode === 'approve' ? 'pi pi-send' : 'pi pi-download')" 
                      (onClick)="save()" 
                      [loading]="loading"
                      [disabled]="form.invalid || itemsArray.length === 0">
            </p-button>
        </div>
    </div>

    <!-- Main Content -->
    <div class="flex-1 p-4 overflow-y-auto">
        <form [formGroup]="form" class="flex flex-column gap-4 max-w-full m-auto" style="width: 1200px;" (ngSubmit)="save()">

            <!-- Bloque 1: Sucursales -->
            <div class="surface-card p-4 border-round shadow-1">
                <h2 class="text-lg font-medium m-0 mb-3 text-900"><i class="pi pi-building mr-2 text-primary"></i>1. Origen y Destino</h2>
                
                <div class="grid">
                    <div class="col-12 md:col-6">
                        <div class="field mb-0">
                            <label class="font-medium text-900 block mb-2">Sucursal Origen <span class="text-red-500">*</span></label>
                            <p-dropdown [options]="sourceBranchesOptions" formControlName="sourceBranchId" optionLabel="name" optionValue="id" placeholder="Seleccione origen" styleClass="w-full" [filter]="true"></p-dropdown>
                        </div>
                    </div>
                    <div class="col-12 md:col-6">
                        <div class="field mb-0">
                            <label class="font-medium text-900 block mb-2">Sucursal Destino <span class="text-red-500">*</span></label>
                            <p-dropdown [options]="targetBranchesOptions" formControlName="targetBranchId" optionLabel="name" optionValue="id" placeholder="Seleccione destino" styleClass="w-full" [filter]="true"></p-dropdown>
                        </div>
                    </div>
                    <div class="col-12" *ngIf="form.hasError('sameBranch')">
                        <small class="text-red-500">La sucursal de origen y destino no pueden ser la misma.</small>
                    </div>

                    <div class="col-12 mt-3" *ngIf="mode === 'create'">
                        <div class="field-checkbox mb-0">
                            <p-checkbox formControlName="isSpontaneous" [binary]="true" inputId="isSpontaneous"></p-checkbox>
                            <label for="isSpontaneous">Es un envío directo (despacha inmediatamente, sin esperar aprobación)</label>
                        </div>
                    </div>
                </div>
            </div>

            <!-- Bloque 2: Artículos -->
            <div class="surface-card p-4 border-round shadow-1">
                <div class="flex justify-content-between align-items-center mb-3">
                    <h2 class="text-lg font-medium m-0 text-900"><i class="pi pi-box mr-2 text-primary"></i>2. Artículos a Transferir</h2>
                    <p-button *ngIf="mode === 'create'" label="Agregar Artículo" icon="pi pi-plus" size="small" [outlined]="true" (onClick)="addItem()"></p-button>
                </div>

                <p-table [value]="itemsArray.controls" styleClass="p-datatable-sm p-datatable-striped" responsiveLayout="scroll">
                    <ng-template pTemplate="header">
                        <tr>
                            <th style="width: 40%">Artículo</th>
                            <th style="width: 15%">Cant. Solicitada</th>
                            <th style="width: 15%" *ngIf="mode !== 'create'">Cant. Despachada</th>
                            <th style="width: 15%" *ngIf="mode === 'receive' || mode === 'view'">Cant. Recibida</th>
                            <th style="width: 5%" *ngIf="mode === 'create'"></th>
                        </tr>
                    </ng-template>
                    <ng-template pTemplate="body" let-ctrl let-i="rowIndex">
                        <tr [formGroup]="ctrl">
                            <td>
                                <p-dropdown *ngIf="mode === 'create'" [options]="itemsOptions" formControlName="itemId" optionLabel="name" optionValue="id" styleClass="w-full" [filter]="true" filterBy="name" appendTo="body" placeholder="Seleccione un artículo..." [virtualScroll]="true" [virtualScrollItemSize]="38"></p-dropdown>
                                <span *ngIf="mode !== 'create'">{{ ctrl.get('itemName')?.value }}</span>
                            </td>
                            <td>
                                <p-inputNumber *ngIf="mode === 'create'" formControlName="requested_quantity" mode="decimal" [min]="1" styleClass="w-full"></p-inputNumber>
                                <span *ngIf="mode !== 'create'">{{ ctrl.get('requested_quantity')?.value }}</span>
                            </td>
                            <td *ngIf="mode !== 'create'">
                                <p-inputNumber *ngIf="mode === 'approve'" formControlName="dispatched_quantity" mode="decimal" [min]="0" styleClass="w-full"></p-inputNumber>
                                <span *ngIf="mode !== 'approve'">{{ ctrl.get('dispatched_quantity')?.value }}</span>
                            </td>
                            <td *ngIf="mode === 'receive' || mode === 'view'">
                                <p-inputNumber *ngIf="mode === 'receive'" formControlName="received_quantity" mode="decimal" [min]="0" styleClass="w-full"></p-inputNumber>
                                <span *ngIf="mode === 'view'">{{ ctrl.get('received_quantity')?.value }}</span>
                            </td>
                            <td class="text-center" *ngIf="mode === 'create'">
                                <p-button icon="pi pi-trash" severity="danger" [text]="true" [rounded]="true" (onClick)="removeItem(i)"></p-button>
                            </td>
                        </tr>
                    </ng-template>
                    <ng-template pTemplate="emptymessage">
                        <tr>
                            <td [attr.colspan]="mode === 'create' ? 3 : (mode === 'approve' ? 3 : 4)" class="text-center py-4 text-500">
                                No hay artículos agregados.
                            </td>
                        </tr>
                    </ng-template>
                </p-table>
            </div>

            <!-- Bloque 3: Logística y Observaciones -->
            <div class="surface-card p-4 border-round shadow-1" *ngIf="mode !== 'create' || form.get('isSpontaneous')?.value">
                <h2 class="text-lg font-medium m-0 mb-3 text-900"><i class="pi pi-truck mr-2 text-primary"></i>3. Logística y Observaciones</h2>
                
                <div class="grid">
                    <div class="col-12 md:col-4">
                        <div class="field">
                            <label class="font-medium text-900 block mb-2">Medio de Envío</label>
                            <input pInputText formControlName="shipping_method" class="w-full" placeholder="Ej: Flete interno, Correo..." />
                        </div>
                    </div>
                    <div class="col-12 md:col-4">
                        <div class="field">
                            <label class="font-medium text-900 block mb-2">Llegada Estimada</label>
                            <p-calendar formControlName="estimated_arrival" [showIcon]="true" styleClass="w-full" appendTo="body"></p-calendar>
                        </div>
                    </div>
                    <div class="col-12 md:col-4">
                        <div class="field">
                            <label class="font-medium text-900 block mb-2">Seguimiento / Remito</label>
                            <input pInputText formControlName="tracking_info" class="w-full" placeholder="Nro seguimiento..." />
                        </div>
                    </div>

                    <div class="col-12 mt-2">
                        <div class="field mb-0">
                            <label class="font-medium text-900 block mb-2">Observaciones</label>
                            <textarea pInputTextarea formControlName="notes" rows="2" class="w-full" placeholder="Observaciones generales..."></textarea>
                        </div>
                    </div>
                </div>
            </div>

            <!-- Bloque de Merma -->
            <div class="surface-card p-4 border-round shadow-1 border-left-3 border-red-500" *ngIf="hasLoss">
                <div class="flex align-items-center mb-3 text-red-500 font-medium">
                    <i class="pi pi-exclamation-triangle mr-2 text-xl"></i>
                    <span>Diferencia en Recepción (Merma Detectada)</span>
                </div>
                <p class="text-sm text-700 mb-3 m-0">Has indicado cantidades recibidas menores a las despachadas. La diferencia se reportará como pérdida. Por favor, indica el motivo.</p>
                <div class="field mb-0">
                    <label class="font-medium text-900 block mb-2">Motivo de la Merma <span class="text-red-500">*</span></label>
                    <textarea pInputTextarea formControlName="loss_reason" rows="2" class="w-full" placeholder="Ej. Frasco roto durante el transporte..."></textarea>
                </div>
            </div>
            
            <div class="surface-card p-4 border-round shadow-1" *ngIf="mode === 'create' && !form.get('isSpontaneous')?.value">
                <h2 class="text-lg font-medium m-0 mb-3 text-900"><i class="pi pi-align-left mr-2 text-primary"></i>3. Observaciones</h2>
                <div class="field mb-0">
                    <textarea pInputTextarea formControlName="notes" rows="2" class="w-full" placeholder="Observaciones generales..."></textarea>
                </div>
            </div>

            <!-- Bloque: Auditoría / Historial -->
            <div class="surface-card p-4 border-round shadow-1" *ngIf="mode !== 'create'">
                <h2 class="text-lg font-medium m-0 mb-3 text-900"><i class="pi pi-history mr-2 text-primary"></i>Historial de Movimientos</h2>
                
                <div class="grid">
                    <div class="col-12 md:col-4" *ngIf="transferData?.createdAt">
                        <span class="text-500 block mb-1">Solicitado por:</span>
                        <div class="font-medium text-900">
                           <i class="pi pi-user mr-1 text-500"></i> {{ transferData?.requestedBy_name || transferData?.requestedById || 'Sistema' }}
                        </div>
                        <div class="text-sm text-500 mt-1"><i class="pi pi-clock mr-1"></i> {{ transferData?.createdAt | date:'medium' }}</div>
                    </div>
                    <div class="col-12 md:col-4" *ngIf="transferData?.dispatchedById">
                        <span class="text-500 block mb-1">Despachado / Aprobado por:</span>
                        <div class="font-medium text-900">
                           <i class="pi pi-user mr-1 text-500"></i> {{ transferData?.dispatchedBy_name || transferData?.dispatchedById }}
                        </div>
                        <div class="text-sm text-500 mt-1" *ngIf="transferData?.status !== 'PENDING'"><i class="pi pi-clock mr-1"></i> {{ transferData?.updatedAt | date:'medium' }}</div>
                    </div>
                    <div class="col-12 md:col-4" *ngIf="transferData?.receivedById">
                        <span class="text-500 block mb-1">Recibido por:</span>
                        <div class="font-medium text-900">
                           <i class="pi pi-user mr-1 text-500"></i> {{ transferData?.receivedBy_name || transferData?.receivedById }}
                        </div>
                        <div class="text-sm text-500 mt-1" *ngIf="transferData?.status === 'COMPLETED'"><i class="pi pi-clock mr-1"></i> {{ transferData?.updatedAt | date:'medium' }}</div>
                    </div>
                    <div class="col-12 md:col-4" *ngIf="transferData?.status === 'REJECTED'">
                        <span class="text-500 block mb-1">Rechazado el:</span>
                        <div class="font-medium text-red-500">
                           <i class="pi pi-times-circle mr-1"></i> {{ transferData?.updatedAt | date:'medium' }}
                        </div>
                    </div>
                </div>
            </div>

        </form>
    </div>
</div>
